var helper = {
    titleCaseForTabs: function (str) {
        var title;
        if (str === 'customerUsername') {
            title = str.split(/(?=[A-Z])/).join(' ').replace('customer', 'Bank');
        } else {
            title = str.split(/(?=[A-Z])/).join(' ').replace('customer', '');
        }
        var splitStr = title.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    },
    changeTableHeaders: function (title) {
        var titleConditioner = title === 'transaction Id' ? 'Transaction ID' : title === 'iba Nto Debit' ? 'IBAN to Debit' : title === 'iba Nto Credit' ? 'IBAN to Credit' : title === 'iba Nto Credit_ M Pay Commission' ? 'IBAN to Credit MPAY Commission' : title === 'amount_ M Pay Commission' ? 'Amount MPAY Commission' : title === 'currency_ M Pay Commission' ? 'Currency MPAY Commission' : title === 'amount_ Bank Commission' ? 'Amount Bank Commission' : title === 'currency_ Bank Commission' ? 'Currency Bank Commission' : title === 'merchant I D' ? 'Merchant ID' : title === 'receipt I D' ? 'Receipt ID' : title === 'txn Id_ T1' ? 'Txn ID (T1)' : title === 'txn Kuik Id_ T1' ? 'Txn KUIK ID (T1)' : title === 'amount_ T1' ? 'Amount (T1)' : title === 'status_ T1' ? 'Status (T1)' : title === 'reversed_ T1' ? 'Reversed (T1)' : title === 'pending Reversal_ T1' ? 'Pending Reversal (T1)' : title === 'reversal Attempts_ T1' ? 'Reversal Attempts (T1)' : title === 'bank Customer Id_ T1' ? 'Bank Customer ID (T1)' : title === 'kuik Customer Id_ T1' ? 'KUIK Customer ID (T1)' : title === 'mno_ T1' ? 'MNO (T1)' : title === 'msisdn_ T1' ? 'MSISDN (T1)' : title === 'bank_ T1' ? 'Bank (T1)' : title === 'iban_ T1' ? 'IBAN (T1)' : title === 'event_ T1' ? 'Event/Receipt (T1)' : title === 'cbs Posting Date_ T1' ? 'CBS Posting Date (T1)' : title === 'cbs Posting Date_ T2' ? 'CBS Posting Date (T2)' : title === 'cbs Reversal Date_ T1' ? 'CBS Reversal Date (T1)' : title === 'cbs Reversal Date_ T2' ? 'CBS Reversal Date (T2)' : title === 'txn Id_ T2' ? 'Txn ID (T2)' : title === 'txn Kuik Id_ T2' ? 'Txn KUIK ID (T2)' : title === 'amount_ T2' ? 'Amount (T2)' : title === 'status_ T2' ? 'Status (T2)' : title === 'reversed_ T2' ? 'Reversed (T2)' : title === 'bank Customer Id_ T2' ? 'Bank Customer ID (T2)' : title === 'kuik Customer Id_ T2' ? 'KUIK Customer ID (T2)' : title === 'mno_ T2' ? 'MNO (T2)' : title === 'msisdn_ T2' ? 'MSISDN (T2)' : title === 'bank_ T2' ? 'Bank (T2)' : title === 'iban_ T2' ? 'IBAN (T2)' : title === 'event_ T2' ? 'Event/Receipt (T2)' : title === 'order Id' ? 'Order ID' : title === 'mpay Transaction Id_ T1' ? 'MPAY Transaction ID (C1)' : title === 'mpay Date' ? 'MPAY Date' : title === 'rbal Date' ? 'RBAL Date' : title === 'iban To Debit_ T1' ? 'IBAN to Debit (C1)' : title === 'iban To Credit_ T1' ? 'IBAN to Credit (C1)' : title === 'rbal Transaction Id' ? 'RBAL Transaction ID' : title === 'iban To Debit_ T2' ? 'IBAN to Debit (C2)' : title === 'iban To Credit_ T2' ? 'IBAN to Credit (C2)' : title === 'mpay Transaction Id_ T2' ? 'MPAY Transaction ID (C2)' : this.titleCaseForTabs(title);
        return titleConditioner;
    },
    changeCSVHeaders: function (title) {
        var titleConditioner = title === 'transaction Id' ? 'TransactionID' : title === 'iba Nto Debit' ? 'IBANtoDebit' : title === 'iba Nto Credit' ? 'IBANtoCredit' : title === 'receipt I D' ? 'ReceiptID' : title === 'iba Nto Credit_ M Pay Commission' ? 'IBANtoCredit_MPayCommission' : title === 'amount_ M Pay Commission' ? 'Amount_MPayCommission' : title === 'currency_ M Pay Commission' ? 'Currency_MPayCommission' : title === 'amount_ Bank Commission' ? 'Amount_BankCommission' : title === 'currency_ Bank Commission' ? 'Currency_BankCommission' : title === 'merchant I D' ? 'MerchantID' : title === 'initiator Bank Id' ? 'Initiator BankID' : title === 'beneficiary Bank Id' ? 'Beneficiary BankID' : title === 'mpay Transaction Id_ T1' ? 'MPAY Transaction ID (C1)' : title === 'mpay Date' ? 'MPAY Date' : title === 'rbal Date' ? 'RBAL Date' : title === 'iban To Debit_ T1' ? 'IBAN to Debit (C1)' : title === 'iban To Credit_ T1' ? 'IBAN to Credit (C1)' : title === 'rbal Transaction Id' ? 'RBAL Transaction ID' : title === 'iban To Debit_ T2' ? 'IBAN to Debit (C2)' : title === 'iban To Credit_ T2' ? 'IBAN to Credit (C2)' : title === 'mpay Transaction Id_ T2' ? 'MPAY Transaction ID (C2)' : this.titleCaseForTabs(title);
        return titleConditioner;
    },
    tableHeadersFormater: function (pathname, title) {
        const uppercaseWords = ["id", "msisdn", "mno", "cbs", "kuik", "iban", "mpay", "rbal", "udid","nuis"];
        let splitStr = title;
        uppercaseWords.map(word => {
            var regEx = new RegExp(word, "ig");
            if (splitStr.toLowerCase().includes(word)) {
                splitStr = splitStr.replace(regEx, word.toUpperCase());
            }
        });

         if(title === 'merchant Personal Number') {
            return 'Leg.Rep Personal Number';
        }
        if(title === 'merchant Msisdn') {
            return 'Leg.Rep MSISDN';
        } 
        if(title === 'merchant Fullname') {
            return 'Leg.Rep Fullname';
        }  
        if(title === 'merchant Name Surname') {
            return 'Leg.Rep Fullname';
        }  
        if(title === 'leg Rep Msisdn') {
            return 'Leg.Rep MSISDN';
        }   
        if(title === 'leg Rep Fullname') {
            return 'Leg.Rep Fullname';
        } 
        if(title === 'leg Rep S S N') {
            return 'Leg.Rep SSN';
        }   
        if(title === 'event Receipt_ T3') {
            return 'Event/Receipt (T3)';
        }  
        if(title === 'event Receipt_ T1') {
            return 'Event/Receipt (T1)';
        } 
        if(title === 'event Receipt_ T2') {
            return 'Event/Receipt (T2)';
        } 
        if(title === 'merchant N U I S') {
            return 'Merchant NUIS';
        }
        if(title === ' M S I S D N') {
            return 'MSISDN';
        }
        if(title === 'txn I D_ T1') {
            return 'Txn ID_T1';
        }
        if(title === 'transaction I D_ T1') {
            return 'Transaction ID_T1';
        }
        if(title === 'validity') {
            return 'Validity (min)';
        }
        if(splitStr === ' M N O') {
            return 'MNO';
        }
        if(splitStr === 'bank Employ ID') {
            return 'Bank Username ID'
        }
        if(splitStr === ' Bank ID') {
            return 'Customer Bank ID'
        }
        if((pathname === '/customer-management' && title === 'index Id') || (pathname === '/subscription-status-report' && title === 'subscription Id')) {
            return 'KUIK Customer ID'
        }
        if(pathname === '/subscription-status-report' && title === 'bank Subscription Code') {
            return 'Customer Bank ID'
        }
        if(pathname === '/p2b-payments-settlement-report' && title === 'mpay Transaction Id_ T1') {
            return 'MPAY Transaction ID (C1)'
        }
        if(pathname === '/p2b-payments-settlement-report' && title === 'iban To Debit_ T1') {
            return 'IBAN to Debit (C1)'
        }
        if(pathname === '/p2b-payments-settlement-report' && title === 'iban To Credit_ T1') {
            return 'IBAN to Credit (C1)'
        }
        if(pathname === '/p2b-payments-settlement-report' && title === 'iban To Debit_ T2') {
            return 'IBAN to Debit (C2)'
        }
        if(pathname === '/p2b-payments-settlement-report' && title === 'iban To Credit_ T2') {
            return 'IBAN to Credit (C2)'
        }
        if(pathname === '/p2b-payments-settlement-report' && title === 'mpay Transaction Id_ T2') {
            return 'MPAY Transaction ID (C2)'
        }
        return splitStr.charAt(0).toUpperCase() + splitStr.slice(1);
    }
}

module.exports = helper;